module.exports = __webpack_public_path__ + "media/images/emoticons/moneybag-d3a16f728d47aa08fd113e50037e67e0.gif";